import { IBreadcrumbItem } from '@fluentui/react';
import * as React from 'react';
import { breadcrumbsReducer, IAllowedAction } from '../reducers/breadcrumbsReducer';

export const BreadcrumbContext = React.createContext<IBreadcrumbs | null>(null);

export interface IBreadcrumbs {
    state: Array<IBreadcrumbItem>;
    dispatch: React.Dispatch<IAllowedAction>;
}

let initialState = new Array<IBreadcrumbItem>();

export function BreadcrumbProvider(props: any) {
    const [state, dispatch] = React.useReducer<React.Reducer<Array<IBreadcrumbItem>, IAllowedAction>>(breadcrumbsReducer, initialState);
    return <BreadcrumbContext.Provider value={{ state, dispatch } as IBreadcrumbs}>{props.children}</BreadcrumbContext.Provider>;
}
